export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/dweller/dashboard/index.js